import { StyleSheet, View } from 'react-native';
import { Typography } from 'ucl';

import PointsIcon from 'components/icons/loyalty-points-icon';
import { isStepCompleted } from 'components/quests/loyalty-quest/utils';
import { LoyaltyQuestStepStatus } from 'generated/graphql-gateway';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

interface IEarnCrownsBadge {
  bonusPoints?: number;
  status: LoyaltyQuestStepStatus;
}

export const EarnCrownsBadge = ({ bonusPoints, status }: IEarnCrownsBadge) => {
  if (!bonusPoints) {
    return null;
  }

  if (isStepCompleted(status)) {
    return (
      <View style={[styles.container, { backgroundColor: primitive.$meltyYellow }]}>
        <PointsIcon size={'3'} fill={primitive.$bbqBrown} />
        <Typography variant={'copyTwo'}>
          {t('questPointsEarned', { points: bonusPoints?.toString() })}
        </Typography>
      </View>
    );
  }

  return (
    <View style={[styles.container, { backgroundColor: primitive.$meltyYellowOpacity20 }]}>
      <PointsIcon size={'3'} fill={primitive.$bbqBrown} />
      <Typography variant={'copyTwo'}>
        {t('questEarnPoints', { points: bonusPoints?.toString() })}
      </Typography>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: spacing.$0_5,
    paddingHorizontal: spacing.$1,
    borderRadius: 3,
    alignItems: 'center',
    flexDirection: 'row',
    gap: spacing.$1,
    alignSelf: 'flex-start',
  },
});
